export default __webpack_public_path__ + "static/media/newsstories-fallback-min.7e938b90.jpg";